import React, { useState } from "react"
import { Box, Spinner } from "@chakra-ui/react"

export function IFrame({ link }) {
  const [loaded, setLoaded] = useState(false)

  return (
    <Box
      layerStyle="foreground"
      position="relative"
      overflow="hidden"
      isLoaded={loaded}
      bg="base.d100"
      pb="56.25%"
      height={0}
    >
      {!loaded && (
        <Spinner
          position="absolute"
          thickness="4px"
          speed="0.65s"
          ml="-1.5rem"
          mt="-1.5rem"
          left="50%"
          top="50%"
          size="lg"
        />
      )}

      <Box
        onLoad={() => setLoaded(true)}
        position="absolute"
        allowFullScreen
        frameBorder="0"
        height="full"
        width="full"
        as="iframe"
        src={link}
        left={0}
        top={0}
      />
    </Box>
  )
}
